export interface ApiResponse<T = unknown> {
  code: string;
  message: string;
  data: T;
}

export const API_RESPONSE_CODES = {
  SUCCESS: "00",
  ERROR: "01",
} as const;

export type ApiResponseCode =
  (typeof API_RESPONSE_CODES)[keyof typeof API_RESPONSE_CODES];
